import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";

import store from "./redux/store";
import "./index.css";
import "./assets/css/brand.css";
import TagManager from "react-gtm-module";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { shouldInitializeTagManager } from "./utils/capabilityUrls";
import { tagManagerLoaded } from "./utils/tagManagerLoaded";

// Two containers: the original app container and marketing's (added by Sam
// 2026-08-27 — moved here from a static index.html snippet, which would have
// baked GTM into every prerendered page INCLUDING the analytics-free 200.html
// fallback that serves seller share links; that exact leak is the July
// incident the post-deploy check guards).
const GTM_CONTAINERS = ["GTM-K8HLJK8X", "GTM-5RZQ7LK6"];

// Capability-bearing URLs must never be exposed to third-party scripts that
// can read window.location before the router has a chance to sanitize it.
if (shouldInitializeTagManager(window.location)) {
  for (const gtmId of GTM_CONTAINERS) {
    // Skip a container the prerendered HTML already carries, or it loads
    // twice and GA4 counts every pageview twice (Trello MzcRAvqf).
    if (!tagManagerLoaded(gtmId)) {
      TagManager.initialize({ gtmId });
    }
  }
}

const app = (
  <HelmetProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
);

// react-snap prerenders each public route to static HTML at build time. When a
// snapshot is present the #root already has children, so hydrate into it;
// otherwise (dev, or a non-prerendered route) render fresh.
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Application root element is missing");
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(app, rootElement);
} else {
  ReactDOM.render(app, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
